import { Injectable } from '@angular/core';
import { ProductDto, ToRequestCityDto, UserPermissionAddressDto, UserPermissionServiceProxy } from './../../../../../shared/service-proxies/service-proxies';
import { BehaviorSubject, Subject } from 'rxjs';
import { extend, rest } from 'lodash';
import { CartService } from './cart.service';
import _ from 'lodash';

/**
 *Her bir teslimat noktasi icin, sepetteki tum urunler bu sinif uzerinde tuutlur.
  *Daha sonra kulllanici, sepettki urunleri farkli noktalara farkli miktarlarda gonderebilecektir.
 */
export class MergedCartAddress  {

  destinationAddress: UserPermissionAddressDto ;

  /**
   * Adrese gonderilm ile ilgili, kullanici bu alan aciklama girebilir.
   */
  shipmentComment : string ;

  /**
   * Noktaya gonderilecek olan urunler.
   * Ilk basta sepetteki tum urunler, tum noktalar icin eklenecektir ilgili bir method ile.
   * Sonrasinda kullanici, bazi noktalardan bazi urunleri cikarabilir.
   */
  products$ : BehaviorSubject<ProductDto[]> = new BehaviorSubject<ProductDto[]>(null);
}



/**
 * Bu service, hedef noktaalrin bir listeye eklenmesi ve listeden cikarilmasi islemlerini yapar.
 * Bunun yaninda, sepetteki tum urunler icin, tum secili noktlara gonderim yapilacak sekilde bir obje olusturur.
 * Tum bu islemler, servedan bagimsiz olarak sadece client tarafinda gerceklesir.
 * Service static bir servis olarak tanimlanmistir, dolayisiyla tarayicida full refresh (F5) yapilana dek, veriler memoryde sankalnir.
 * 
 * ONEMLI NOT: Servisin adi yanli olarak olusturulmus, refactoring kisminda duzeltilmelidir. - HA 01.01.2021
 */
@Injectable({
  providedIn: 'root'
})
export class DestatinationAddressService {

  ORDERTYPE = 12 //Satis noktalarina talep tipi 12'dir. Bu ekrandan sadece satis noktalarina talep yetkisi olan noktalara ait sehirlerin listesi alinir.
		
  cities$ : BehaviorSubject<ToRequestCityDto[]> = new BehaviorSubject<ToRequestCityDto[]>([]);
  addresses$: BehaviorSubject<UserPermissionAddressDto[]> = new BehaviorSubject<UserPermissionAddressDto[]>([]);

  selectedAddresses$: BehaviorSubject<UserPermissionAddressDto[]> = new BehaviorSubject<UserPermissionAddressDto[]>([]);

  /**
   * Sepetteki tum urunler, her bir teslimat noktasi icin, mergedCartAndAddresses$ objesinde olusturulur.
   */
  mergedCartAndAddresses$: BehaviorSubject<MergedCartAddress[]> = new BehaviorSubject<MergedCartAddress[]>([]);

  constructor(
    private _userPermissionService: UserPermissionServiceProxy,
    private _cartService : CartService
    ) { }
  

    /**
     * Kullanicinin gormeye yetkili oldugu adreslere iliskin sehir listesinin getirir.
     * Sehir listesi daha once yuklenmis ise, sunucuya tekrar gidilmez.
     */
  loadUserAssignedCityList() {
  
    if (this.cities$.value.length == 0){
   
    this._userPermissionService.getUserAssignedCityList([this.ORDERTYPE])
			.subscribe((cityList) => {

				this.cities$.next(cityList);

        
			});

    }
	}


  /**
   * Belirtilen sehirdeki, talep edilmeye yetkili olunan adreslerin listesini sunucudan getirir.
   * @param cityId 
   */
  loadUserAssignedAddresses(cityId:number, searcKeyword: string) {
		this._userPermissionService
			.getUserCitiesAddressWithUserAssignedAddresses([this.ORDERTYPE], cityId, searcKeyword)
			.subscribe(resp => {

				this.addresses$.next(resp.addresses);
			});
	}


  /**
   * Parametre olarak gonderilen adresleri, 
   * selectedAddresses$ objesine ekler.
   * @param addresses 
   */
  addSelectedAddresses(addresses: UserPermissionAddressDto[]){
     const list = this.selectedAddresses$.value

     addresses.forEach(element => {
        const hasExistAddress = this.selectedAddresses$.value.find(x=>x.id == element.id);

        if (! hasExistAddress){
          list.push(element);
        }
        
     });

     this.selectedAddresses$.next(list);
  }

  /**
   * Belirtilen adres, selectedAddresses$ listesinden cikarilir.
   * @param address 
   */
  removeSelectedAddress(address: UserPermissionAddressDto){
      const list = this.selectedAddresses$.value;
      const index = list.findIndex(x=>x.id == address.id);

      //Belirtilen adres listeden cikariliyor.
      list.splice(index, 1);

      //Liste yenileniyor.
      this.selectedAddresses$.next(list);
  }


  /**
   * Sepetteki urunlerle, teslimat noktalarini birlestirir.
   * Sepetteki tum urunler, her bir teslimat noktasina gidecek sekilde ilgili sinif icine yerlestirilir.
   */
  mergeCartToAddress(){
    const list : MergedCartAddress[] = [] ;

    this.selectedAddresses$.value.forEach(address => {
        let newMerged = new MergedCartAddress();
        
        newMerged.destinationAddress = address ;

        //Sepetteki urunler, products degiskenine clonlaniyor, referans'tan kurtulmak icin..
        let products = JSON.parse(JSON.stringify(this._cartService.products$.value));
        var clonnedProducts : ProductDto[] = <ProductDto[]>products ; 


        newMerged.products$.next(clonnedProducts);

        list.push(newMerged);
    });

    this.mergedCartAndAddresses$.next(list);

  }

  /**
   * Daha once sepete sevkiyat adresi olarak eklenmis tum adresler temizlenir.
   */
  clearAllAddresses(){
    this.mergedCartAndAddresses$.next([]);
  }

  /**
   * Urun ve Adreslerin merge edildigi ana obje icinden, belirtilen adres cikarilir.
   * "Kullanici, noktaya sevkiyat isleminden vazgecmistir."
   * @param address 
   */
  removeMergedAddress(address: UserPermissionAddressDto){
      const list  = this.mergedCartAndAddresses$.value ;

      const index = list.findIndex(x=>x.destinationAddress.id == address.id) ;
      list.splice(index, 1) ;

      this.mergedCartAndAddresses$.next(list);
  }

  /**
   * Belirtilen adres icindeki, belirtilen urun, merge listesinden cikarialir.
   * "Kullanici X noktasina, Y urununu gondermekten vazgecmistir"
   * @param addressId 
   * @param productId 
   */
  removeMergedProduct(addressId, productId){

      //Ana liste degiskene aliniyor.
      const list = this.mergedCartAndAddresses$.value ;

      //Cikarilacak urunun yer aldigi adres tespit edilir.
      const address = list.find(x => x.destinationAddress.id == addressId);
      
      //Adresin icindeki urunlerin listesi degiskene alinir.
      const productList = address.products$.value ;

      //Urun listesindeki, cikarilmak (silinmek) istenen urunun index'i bulunur.
      const productIndex = productList.findIndex(x => x.id == productId);

      //Belirtilen urun, urun listesinden cikarilir.
      productList.splice(productIndex, 1) ;

      //Urun listesş tekrar ilgili adres listesine set edilerek refresh edilmis olur.
      address.products$.next(productList);
  }


}
